import React, { FunctionComponent, useEffect, useState } from 'react';
import { Button, IconButton, Paper, Dialog } from '../../tailwindcomponents';
import { palette } from '../../theme/palette';
import { informationRow } from '../../types/security';
import SecurityApi from '../../api/security';
import { Typography, Input } from '../../tailwindcomponents';
import { Edit, AddBox, Delete, AccountCircle } from '../../components/icons';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducer';
import ProfileImg from '../../components/Images/ProfileImg';

type InformationPageProps = {
    isSecurityAdmin: Boolean
}

const InformationPage: FunctionComponent<InformationPageProps> = ({ isSecurityAdmin }) => {
    const [allInformationRows, setAllInformationRows] = useState<informationRow[]>([]);
    const [allDates, setAllDates] = useState<string[]>([]);
    const [commentDialogOpen, setCommentDialogOpen] = useState<boolean>(false);
    const [deleteCommentDialogOpen, setDeleteCommentDialogOpen] = useState<boolean>(false);
    const [commentToAdd, setCommentToAdd] = useState<string>("");
    const [commentType, setCommentType] = useState<"create" | "update">("create");
    const [selectedComment, setSelectedComment] = useState<informationRow>();
    const today = new Date();
    const formattedToday = "" + (today.getDate() <= 9 ? "0" + today.getDate() : today.getDate()) + "." + ((today.getMonth() + 1) <= 9 ? "0" + (today.getMonth() + 1) : (today.getMonth() + 1)) + "." + today.getFullYear();
    const formattedYesterday = "" + ((today.getDate() - 1) <= 9 ? "0" + (today.getDate() - 1) : (today.getDate() - 1)) + "." + ((today.getMonth() + 1) <= 9 ? "0" + (today.getMonth() + 1) : (today.getMonth() + 1)) + "." + today.getFullYear();
    const store = useSelector((state: RootState) => state);
    const user = store.user.me;
    const users = store.employees.all_employees;
    const [imageErrors, setImageErrors] = useState<Record<string, boolean>>({});

    useEffect(() => {
        refresh();
    }, []);

    const onCommentDialogClose = (status: boolean) => {
        if (status && commentType === "create") {
            SecurityApi.CreateNewInformationRow(user.user_id, commentToAdd).then(res => {
                refresh();
            });
        }
        if (status && commentType === "update" && selectedComment !== undefined) {
            SecurityApi.UpdateInformationRow(commentToAdd, selectedComment.id, user.user_id).then(res => {
                refresh();
            });
        }
        setCommentToAdd("");
        setCommentDialogOpen(false);
    }

    const refresh = () => {
        let tempDates: string[] = [];
        SecurityApi.GetAllInformationRows().then(res => {
            setAllInformationRows(res.data.sort(function (a, b) {
                return new Date(b.created_date).getTime() - new Date(a.created_date).getTime();
            }));
            res.data.map(comment => {
                if (tempDates.some(date => date === comment.created_date_text.substring(0, 10)) === false) {
                    tempDates.push(comment.created_date_text.substring(0, 10));
                }
            });
            setAllDates(tempDates);
        });
    }

    const openCommentDialog = (type: "create" | "update", comment?: informationRow) => {
        setCommentType(type);
        setCommentDialogOpen(true);
        if (type === "update" && comment !== undefined) {
            setSelectedComment(comment);
            setCommentToAdd(comment.text);
        }
    }

    const openDeleteCommentDialog = (comment?: informationRow) => {
        setDeleteCommentDialogOpen(true);
        setSelectedComment(comment);
    }

    const onDeleteCommentDialogClose = (status: boolean) => {
        if (status === true && selectedComment !== undefined) {
            deleteComment(selectedComment.id);
            setDeleteCommentDialogOpen(false);
        } else if (status === false) {
            setDeleteCommentDialogOpen(false);
        }
    }

    const deleteComment = (commentId: number) => {
        SecurityApi.DeleteInformationRow(commentId, user.user_id).then(res => {
            refresh();
        });
    }

    const lessThanAWeekAgo = (date: Date) => {
        const now = new Date().getTime();
        const oneWeekAgo = now - 7 * 24 * 60 * 60 * 1000;
        return date.getTime() > oneWeekAgo;
    }

    const handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
        const target = event.target as HTMLImageElement;
        setImageErrors((prevErrors) => ({
            ...prevErrors,
            [target.src]: true,
        }));
    }

    return (
        <div className="flex flex-wrap">
            {isSecurityAdmin && <div className="w-full">
                <div className="relative left-4 top-[5px] mb-4">
                    <Button className="absolute" endIcon={<AddBox />} variant="contained" color="primary" size="medium" onClick={() => openCommentDialog("create")}>Add Message</Button>
                </div>
            </div>}
            {allDates.map(date => (
                <div className="flex flex-row flex-wrap">
                    <div className="w-1/6"></div>
                    <div className="w-2/3">
                        <Typography text={date === formattedToday ? "Today" : date === formattedYesterday ? "Yesterday" : date} textDecoration variant="h2" align="center" margin={[0, 0, 2, 0]} />
                        {allInformationRows.filter(filteredRow => filteredRow.created_date_text.substring(0, 10) === date).map((row, index) => (
                            // Old Paper, shows the messages from user as yellow
                            // <Paper variant="elevation" elevation={5} className={row.last_modified_by_name === null && row.created_by_name === user.display_name ? classes.myCommentsContainer : row.last_modified_by_name === user.display_name ? classes.myCommentsContainer : classes.commentsContainer}>
                            // New Paper, shows the messages from the last week as yellow
                            // row.created_date acts like a string even though it is classified as a Date, that's why it is constructed into a new Date
                            <Paper key={row.id} variant="elevation" elevation={5} className="pb-2 pl-6 pt-2 w-full mb-6" style={lessThanAWeekAgo(new Date(row.created_date.toString())) ? { backgroundColor: palette.status.actv, color: '#000' } : { backgroundColor: palette.accentBlue, color: '#fff' }}>
                                <div className="flex flex-row flex-wrap items-start">
                                    <div className="w-1/12 flex justify-center">
                                        {/* If the <img> returns an error, show profile icon */}
                                        {imageErrors[row.created_by_user_image] ?
                                            <AccountCircle className="h-6 w-6 rounded-full"></AccountCircle>
                                            :
                                            <ProfileImg imgKey={index} imgSize="xs" userName={users?.find(s => s.Id === row.created_by_employee_id)?.userName?.split('@')[0]} />
                                       }
                                    </div>
                                    <div className="w-5/6">
                                        <div className="flex flex-wrap">
                                            <div className="w-auto">
                                                <Typography align="left" display="inline" text={(row.last_modified_by_name !== null ? row.last_modified_by_name : row.created_by_name) + " - " + (row.last_modified_date_text !== "" ? "edited " + row.last_modified_date_text : row.created_date_text)} variant="caption" />
                                            </div>
                                        </div>
                                        <div className="w-full">
                                            <Typography display="inline" customFontSize={20} text={row.text} variant="body1" />
                                        </div>
                                    </div>
                                    {user.display_name === row.created_by_name && isSecurityAdmin &&  //No user id in row object
                                        <div className="w-1/12">
                                            <IconButton onClick={() => openCommentDialog("update", row)} style={{ color: palette.backgroundPaper }}><Edit color={lessThanAWeekAgo(new Date(row.created_date.toString())) ? "primary" : "inherit"} /></IconButton>
                                            <IconButton onClick={() => openDeleteCommentDialog(row)} style={{ color: palette.backgroundPaper }}><Delete color="error" /></IconButton>
                                        </div>
                                    }
                                </div>
                            </Paper>
                        ))}
                    </div>
                    <div className="w-1/6"></div>
                </div>
            ))}
            <Dialog
                visible={commentDialogOpen}
                max_width="md"
                title="Please type in your comment"
                show_options={true}
                strict={false}
                onClose={(status: boolean) => { onCommentDialogClose(status) }}
                context={
                    <div className="flex flex-wrap justify-center">
                        <Input multiline={true} help_text={"Type in your comment"} label_text={"Comment to be added"} value={commentToAdd} onTextChange={(text: string) => { setCommentToAdd(text) }} type="text" width={80} />
                    </div>
                }
            />
            <Dialog
                visible={deleteCommentDialogOpen}
                max_width="md"
                title="Are you sure you want to delete the message?"
                show_options={true}
                strict={false}
                onClose={(status: boolean) => { onDeleteCommentDialogClose(status) }}
                context={selectedComment && <div>
                    <Typography align="left" display="inline" text={selectedComment.text} variant="body1" color="primary" />
                </div>}
            />
        </div>
    );
};
export default InformationPage;
